import '@/lib/typedef';
import client from '@/lib/http-client';

const endpoint = '/otp';

export default {
	generate(params, cb, errorCb) {
		const url = `${endpoint}/generate`;
		client.get(url, { params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	validate(params, cb, errorCb) {
		const url = `${endpoint}/validate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
